module.exports = __webpack_public_path__ + "img/1_008.1f338e69.jpg";